import * as React from 'react';
import Helmet from 'react-helmet';
import produce from 'immer';
import { seoImages } from '../../../../server/utils/urlConstants';

export const getPathFromUrl = url => {
  return url.split('?')[0];
};

const defaultSEO = {
  title: 'ONEHOPE Wine | Buy Inspired & Award-Winning Wine, Gift Boxes & More',
  image: `${seoImages}ONEHOPE-Banner.jpg`,
  imageHeight: '593',
  imageWidth: '1898',
  imageAlt: 'ONEHOPE serve + celebrate',
  keywords: `Wine,United States,charity`,
  description:
    'ONEHOPE Wine is a world-class vineyard in Napa Valley that makes a positive impact on the world with every bottle sold. See whatʼs in store! Indulge. Do Good. Wine Not?',
};

type SEOProps = {
  seoDescription?: string;
  seoImage?: string;
  seoTitle?: string;
  seoImageWidth?: string;
  seoImageHeight?: string;
};

export const SEO = ({
  seoDescription,
  seoImage,
  seoTitle,
  seoImageWidth,
  seoImageHeight,
}: SEOProps) => {
  const seoObj = produce(defaultSEO, draft => {
    if (seoTitle) {
      draft.title = `${seoTitle} | ${defaultSEO.title}`;
    }
    if (seoImage) {
      draft.image = seoImage;
    }
    if (seoImageWidth) {
      draft.imageWidth = seoImageWidth;
    }
    if (seoImageHeight) {
      draft.imageHeight = seoImageHeight;
    }
    if (seoDescription) {
      draft.description = seoDescription;
    }
  });
  const { href } = window.location;
  const {
    title,
    image,
    description,
    imageWidth,
    imageHeight,
    keywords,
  } = seoObj;
  const canonical = getPathFromUrl(href);
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={seoDescription} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content={imageWidth} />
      <meta property="og:image:height" content={imageHeight} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="ONEHOPE Wine" />
      <meta property="twitter:card" content="summary" />
      <meta property="twitter:creator" content="@ONEHOPEWINE" />
      <meta property="twitter:site" content="@ONEHOPEWINE" />
      <meta property="twitter:description" content={description} />

      <meta property="fb:app_id" content={process.env.FACEBOOK_ID} />
      <meta
        property="google-site-verification"
        content={process.env.GOOGLE_ID}
      />

      <link rel="canonical" href={canonical} />
    </Helmet>
  );
};
